import React from 'react';

export default function Menu({ difficulty, setDifficulty, onPlay, onLeaderboard }) {
  return (
    <div className="menu-wrap fade-in">
      <div className="logo-area">
        <span className="title logo-main">Marvel Mayhem</span>
        <span className="title logo-sub">Trivia</span>
        <p className="byline">by Jonah</p>
      </div>

      <div className="card" style={{ padding: '28px' }}>
        <p style={{ textAlign: 'center', color: 'var(--muted)', fontSize: 13, letterSpacing: 3, textTransform: 'uppercase', fontFamily: "'Rajdhani', sans-serif", marginBottom: 20 }}>
          Select Difficulty
        </p>

        <div className="diff-grid">
          {['easy', 'medium', 'hard', 'impossible'].map((d) => (
            <button
              key={d}
              className={`diff-btn diff-${d} ${difficulty === d ? 'selected' : ''}`}
              onClick={() => setDifficulty(d)}
            >
              {d.toUpperCase()}
              <span className="diff-desc">
                {d === 'easy' && '100 pts base'}
                {d === 'medium' && '200 pts base'}
                {d === 'hard' && '350 pts base'}
                {d === 'impossible' && '500 pts base'}
              </span>
            </button>
          ))}
        </div>

        <div className="divider" />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button
            className="btn btn-primary"
            onClick={() => difficulty && onPlay(difficulty)}
            style={{ opacity: difficulty ? 1 : 0.4, width: '100%', fontSize: 22 }}
          >
            ⚡ ASSEMBLE &amp; PLAY
          </button>
          <button className="btn btn-gold" onClick={onLeaderboard} style={{ width: '100%' }}>
            🏆 LEADERBOARD
          </button>
        </div>

        <div className="divider" />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', textAlign: 'center' }}>
          {[['3', 'Rounds'], ['5', "Q's / Round"], ['15s', 'Per Question']].map(([v, l]) => (
            <div key={l}>
              <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 28, color: 'var(--red)' }}>{v}</div>
              <div style={{ fontSize: 10, letterSpacing: 2, color: 'var(--muted)', textTransform: 'uppercase', fontFamily: "'Rajdhani', sans-serif" }}>{l}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
